import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { GeneralService } from '../../general.service';

@Component({
  selector: 'app-programme-information',
  templateUrl: './programme-information.component.html',
  styleUrls: ['./programme-information.component.scss']
})
export class ProgrammeInformationComponent implements OnInit {

  public logo = "";

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService
  ) { 
    this.logo = "https://www.iwcf.org/wp-content/uploads/2018/12/iwcflogo.png";
  }

  ngOnInit() {
  }
}